export const getMappedValue = <T, K extends keyof T>(
  obj: T,
  key: K,
  value: T[K]
): T => {
  return {
    ...obj,
    [key]: value,
  };
};

//SF-3869 function only useful to avoid compatibility problems between old and new monitoring source widget values
export const correctWidgetMonitoringSourceValue = (
  value: string
): DevicesSourceFilter =>
  value.replace(/\b\w/g, (firstLetter) =>
    firstLetter.toUpperCase()
  ) as DevicesSourceFilter;
